import { IControlePatrimonioService } from "./controlePatrimonioService";
import { AxiosError } from "axios";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import {
  GetAllInspecaoPatrimonioRequest,
  GetAllInspecaoPatrimonioResponse,
} from "../daos/read/get_all_inspecao_patrimonio";
import {
  GetInspecaoPatrimonioByIdRequest,
  GetInspecaoPatrimonioByIdResponse,
} from "../daos/read/get_inspecao_patrimonio_by_id";
import {
  CreateInspecaoPatrimonioRequest,
  CreateInspecaoPatrimonioResponse,
} from "../daos/create/create_inspecao_patrimonio";
import {
  UpdateInspecaoPatrimonioRequest,
  UpdateInspecaoPatrimonioResponse,
} from "../daos/update/update_inspecao_patrimonio";
import {
  DeleteInspecaoPatrimonioRequest,
  DeleteInspecaoPatrimonioResponse,
} from "../daos/delete/delete_inspecao_patrimonio";
import {
  GetAllInspecaoPatrimonioItensRequest,
  GetAllInspecaoPatrimonioItensResponse,
} from "../daos/read/get_all_inspecao_patrimonio_itens";
import {
  GetInspecaoPatrimonioItensByIdRequest,
  GetInspecaoPatrimonioItensByIdResponse,
} from "../daos/read/get_inspecao_patrimonio_itens_by_id";
import {
  CreateInspecaoPatrimonioItensRequest,
  CreateInspecaoPatrimonioItensResponse,
} from "../daos/create/create_inspecao_patrimonio_itens";
import {
  UpdateInspecaoPatrimonioItensRequest,
  UpdateInspecaoPatrimonioItensResponse,
} from "../daos/update/update_inspecao_patrimonio_itens";
import {
  DeleteInspecaoPatrimonioItensRequest,
  DeleteInspecaoPatrimonioItensResponse,
} from "../daos/delete/delete_inspecao_patrimonio_itens";
import {
  GetAllPatrimonioChecklistMaquinaEquipRequest,
  GetAllPatrimonioChecklistMaquinaEquipResponse,
} from "../daos/read/get_all_patrimonio_checklist_maquina_equip";
import {
  GetPatrimonioChecklistMaquinaEquipByIdRequest,
  GetPatrimonioChecklistMaquinaEquipByIdResponse,
} from "../daos/read/get_patrimonio_checklist_maquina_equip_by_id";
import {
  CreatePatrimonioChecklistMaquinaEquipRequest,
  CreatePatrimonioChecklistMaquinaEquipResponse,
} from "../daos/create/create_patrimonio_checklist_maquina_equip";
import {
  UpdatePatrimonioChecklistMaquinaEquipRequest,
  UpdatePatrimonioChecklistMaquinaEquipResponse,
} from "../daos/update/update_patrimonio_checklist_maquina_equip";
import {
  DeletePatrimonioChecklistMaquinaEquipRequest,
  DeletePatrimonioChecklistMaquinaEquipResponse,
} from "../daos/delete/delete_patrimonio_checklist_maquina_equip";
import {
  GetAllControledePatrimonioRequest,
  GetAllControledePatrimonioResponse,
} from "../daos/read/get_all_controlede_patrimonio";
import {
  GetControlePatrimonioByIdRequest,
  GetControlePatrimonioByIdResponse,
} from "../daos/read/get_controle_patrimonio_by_id";
import {
  CreateControlePatrimonioRequest,
  CreateControlePatrimonioResponse,
} from "../daos/create/create_controle_patrimonio";
import {
  UpdateControlePatrimonioRequest,
  UpdateControlePatrimonioResponse,
} from "../daos/update/update_controle_patrimonio";
import {
  DeleteControlePatrimonioRequest,
  DeleteControlePatrimonioResponse,
} from "../daos/delete/delete_controle_patrimonio";
import {
  CreateControlePatrimonioControleRequest,
  CreateControlePatrimonioControleResponse,
} from "../daos/create/create_controle_patrimonio_controle";
import {
  GetAllControlePatrimonioControleRequest,
  GetAllControlePatrimonioControleResponse,
} from "../daos/read/get_all_controle_patrimonio_controle";
import {
  GetControlePatrimonioControleByIdRequest,
  GetControlePatrimonioControleByIdResponse,
} from "../daos/read/get_controle_patrimonio_controle_by_id";
import {
  UpdateControlePatrimonioControleRequest,
  UpdateControlePatrimonioControleResponse,
} from "../daos/update/update_controle_patrimonio_controle";
import {
  DeleteControlePatrimonioControleRequest,
  DeleteControlePatrimonioControleResponse,
} from "../daos/delete/delete_controle_patrimonio_controle";
import {
  GetAllControledePatrimonioInspecaoRequest,
  GetAllControledePatrimonioInspecaoResponse,
} from "../daos/read/get_all_controlede_patrimonio_inspecao";
import {
  CreateControledePatrimonioInspecaoRequest,
  CreateControledePatrimonioInspecaoResponse,
} from "../daos/create/create_controlede_patrimonio_inspecao";
import {
  UpdateControledePatrimonioInspecaoRequest,
  UpdateControledePatrimonioInspecaoResponse,
} from "../daos/update/update_controlede_patrimonio_inspecao";
import {
  DeleteControledePatrimonioInspecaoRequest,
  DeleteControledePatrimonioInspecaoResponse,
} from "../daos/delete/delete_controlede_patrimonio_inspecao";
import {
  DropDownMaquinaEquipRequest,
  DropDownMaquinaEquipResponse,
} from "../daos/read/get_drop_down_maquina_equip";
import {
  CreateMaquinasEquipItensRequest,
  CreateMaquinasEquipItensResponse,
} from "../daos/create/create_maquinas_equip_itens";
import {
  DeleteMaquinasEquipItensRequest,
  DeleteMaquinasEquipItensResponse,
} from "../daos/delete/delete_maquinas_equip_itens";
import {
  GetAllMaquinasEquipItensRequest,
  GetAllMaquinasEquipItensResponse,
} from "../daos/read/get_all_maquinas_equip_itens";
import {
  UpdateMaquinasEquipItensRequest,
  UpdateMaquinasEquipItensResponse,
} from "../daos/update/update_maquinas_equip_itens";
import {
  CreateMaquinaEquipArquivoRequest,
  CreateMaquinaEquipArquivoResponse,
} from "../daos/create/create_maquina_equip_arquivo";
import {
  DeleteMaquinaEquipArquivoRequest,
  DeleteMaquinaEquipArquivoResponse,
} from "../daos/delete/delete_maquina_equip_arquivo";
import {
  GetAllControlePatrimonioArquivoRequest,
  GetAllControlePatrimonioArquivoResponse,
} from "../daos/read/get_all_controle_patrimonio_arquivo";
import {
  GetMaquinaEquipArquivoByIdRequest,
  GetMaquinaEquipArquivoByIdResponse,
} from "../daos/read/get_maquina_equip_arquivo_by_id";
import {
  UpdateMaquinaEquipArquivoRequest,
  UpdateMaquinaEquipArquivoResponse,
} from "../daos/update/update_maquina_equip_arquivo";
import {
  DownloadControlePatrimonioArquivoRequest,
} from "../daos/read/download_controle_patrimonio_arquivo";
import {
  GetControleCentroCustoByIdRequest,
  GetControleCentroCustoByIdResponse,
} from "../daos/read/get_controle_centro_custo_by_id";
import {
  GetControleCentroCustoEstatisticasRequest,
  GetControleCentroCustoEstatisticasResponse,
} from "../daos/read/get_controle_centro_custo_estatisticas";
import {
  UpdateMetaStatusControleCentroCustoRequest,
  UpdateMetaStatusControleCentroCustoResponse,
} from "../daos/update/update_meta_status_controle_centro_custo";
import {
  CopyInspecaoMaquinaEquipRequest,
  CopyInspecaoMaquinaEquipResponse,
} from "../daos/create/copy_inspecao_maquina_equip";
import {
  GetInspecaoMaquinasEquipByIdRequest,
  GetInspecaoMaquinasEquipByIdResponse,
} from "../daos/read/get_inspecao_maquinas_equip_by_id";
import {
  GetAllInspecaoMaquinasEquipItemRequest,
  GetAllInspecaoMaquinasEquipItemResponse,
} from "../daos/read/get_all_inspecao_maquinas_equip_item";
import {
  UpdateInspecaoMaquinasEquipDetailRequest,
  UpdateInspecaoMaquinasEquipDetailResponse,
} from "../daos/update/update_inspecao_maquinas_equip_detail";
import {
  DownloadInspecaoMaquinaEquipArquivoRequest,
  DownloadInspecaoMaquinaEquipArquivoResponse,
} from "../daos/read/download_inspecao_maquina_equip_arquivo";
import {
  CreateManutencaoRequest,
  CreateManutencaoResponse,
} from "../daos/create/create_manutencao";
import {
  GetAllManutencaoListaRequest,
  GetAllManutencaoListaResponse,
} from "../daos/read/get_all_manutencao";
import {
  GetManutencaoByIdRequest,
  GetManutencaoByIdResponse,
} from "../daos/read/get_manutencao_by_id";
import {
  DeleteManutencaoByIdRequest,
  DeleteManutencaoByIdResponse,
} from "../daos/delete/delete_manutencao_by_id";
import {
  UpdateManutencaoRequest,
  UpdateManutencaoResponse,
} from "../daos/update/update_manutencao";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { GetManutencaoGerenciarArquivoByIdRequest } from "../daos/read/get_manutencao_gerenciar_arquivo_by_id";
import { GetAllChecklistMaquinaEquipRequest, GetAllChecklistMaquinaEquipResponse } from "../daos/read/get_all_checklist_maquina_equip";
import { GetChecklistMaquinaEquipByIdRequest, GetChecklistMaquinaEquipByIdResponse } from "../daos/read/get_checklist_maquina_equip_by_id";
import { CreateChecklistMaquinaEquipRequest, CreateChecklistMaquinaEquipResponse } from "../daos/create/create_checklist_maquina_equip";
import { UpdateChecklistMaquinaEquipRequest, UpdateChecklistMaquinaEquipResponse } from "../daos/update/update_checklist_maquina_equip";
import { DeleteChecklistMaquinaEquipRequest, DeleteChecklistMaquinaEquipResponse } from "../daos/delete/delete_checklist_maquina_equip";
import { GetAllChecklistMaquinaEquipItemRequest, GetAllChecklistMaquinaEquipItemResponse } from "../daos/read/get_all_checklist_maquina_equip_itens";
import { GetChecklistMaquinaEquipItemByIdRequest, GetChecklistMaquinaEquipItemByIdResponse } from "../daos/read/get_checklist_maquina_equip_item_by_id";
import { CreateChecklistMaquinaEquipItemRequest, CreateChecklistMaquinaEquipItemResponse } from "../daos/create/create_checklist_maquina_equip_itens";
import { UpdateChecklistMaquinaEquipItemRequest, UpdateChecklistMaquinaEquipItemResponse } from "../daos/update/update_checklist_maquina_equip_item";
import { DeleteChecklistMaquinaEquipItemRequest, DeleteChecklistMaquinaEquipItemResponse } from "../daos/delete/delete_checklist_maquina_equip_itens";
import { GetAllPatrimonioMaquinaEquipRequest, GetAllPatrimonioMaquinaEquipResponse } from "../daos/read/get_all_patrimonio_maquina_equip";
import { GetPatrimonioMaquinaEquipByIdRequest, GetPatrimonioMaquinaEquipByIdResponse } from "../daos/read/get_patrimonio_maquina_equip_by_id";
import { CreatePatrimonioMaquinaEquipRequest, CreatePatrimonioMaquinaEquipResponse } from "../daos/create/create_patrimonio_maquina_equip";
import { UpdatePatrimonioMaquinaEquipRequest, UpdatePatrimonioMaquinaEquipResponse } from "../daos/update/update_patrimonio_maquina_equip";
import { DeletePatrimonioMaquinaEquipRequest, DeletePatrimonioMaquinaEquipResponse } from "../daos/delete/delete_patrimonio_maquina_equip";
import { GetAllPatrimonioCentroCustoRequest, GetAllPatrimonioCentroCustoResponse } from "../daos/read/get_all_patrimonio_centro_custo";
import { GetPatrimonioCentroCustoByIdRequest, GetPatrimonioCentroCustoByIdResponse } from "../daos/read/get_patrimonio_centro_custo_by_id";
import { CreatePatrimonioCentroCustoRequest, CreatePatrimonioCentroCustoResponse } from "../daos/create/create_patrimonio_centro_custo";
import { UpdatePatrimonioCentroCustoRequest, UpdatePatrimonioCentroCustoResponse } from "../daos/update/update_patrimonio_centro_custo";
import { DeletePatrimonioCentroCustoRequest, DeletePatrimonioCentroCustoResponse } from "../daos/delete/delete_patrimonio_centro_custo";
import { GetChecklistMaquinaEquipDropDownResponse } from "../daos/read/get_drop_down_checklist_maquina_equip";
import { GetPatrimonioChecklistInfoRequest, GetPatrimonioChecklistInfoResponse } from "../daos/read/get_patrimonio_checklist_info";
import { GetAllOcorrenciaInspecaoPatrimonioRequest, GetAllOcorrenciaInspecaoPatrimonioResponse } from "../daos/read/get_all_ocorrencia_inspecao_patrimonio";
import { GetOcorrenciaInspecaoPatrimonioByIdRequest, GetOcorrenciaInspecaoPatrimonioByIdResponse } from "../daos/read/get_ocorrencia_inspecao_patrimonio_by_id";
import { CreateOcorrenciaInspecaoPatrimonioRequest, CreateOcorrenciaInspecaoPatrimonioResponse } from "../daos/create/create_ocorrencia_inspecao_patrimonio";
import { UpdateOcorrenciaInspecaoPatrimonioRequest, UpdateOcorrenciaInspecaoPatrimonioResponse } from "../daos/update/update_ocorrencia_inspecao_patrimonio";
import { DeleteOcorrenciaInspecaoPatrimonioRequest, DeleteOcorrenciaInspecaoPatrimonioResponse } from "../daos/delete/delete_ocorrencia_inspecao_patrimonio";
import { DownloadOcorrenciaInspecaoPatrimonioArquivosRequest } from "../../../entregaObras/data/daos/read/download_Ocorrencia_Inspecao_Arquivos";

export class ControlePatrimonioService implements IControlePatrimonioService {
  async getAllControlePatrimonio(
    request: GetAllControledePatrimonioRequest,
  ): Promise<GetAllControledePatrimonioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllControledePatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getByIdControlePatrimonio({
    idMaquinaEquip,
  }: GetControlePatrimonioByIdRequest): Promise<GetControlePatrimonioByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/${idMaquinaEquip}`,
      );
      const response =
        handleAxiosResponse<GetControlePatrimonioByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createControlePatrimonio(
    request: CreateControlePatrimonioRequest,
  ): Promise<CreateControlePatrimonioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateControlePatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateControlePatrimonio(
    request: UpdateControlePatrimonioRequest,
  ): Promise<UpdateControlePatrimonioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateControlePatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteControlePatrimonio({
    idMaquinaEquip,
  }: DeleteControlePatrimonioRequest): Promise<DeleteControlePatrimonioResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/${idMaquinaEquip}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteControlePatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async dropDownMaquinaEquip(
    _: DropDownMaquinaEquipRequest,
  ): Promise<DropDownMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/maquina-equip/dropdown`,
      );
      const response =
        handleAxiosResponse<DropDownMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async downloadControlePatrimonioArquivo({
    idMaquinaEquipArquivo,
  }: DownloadControlePatrimonioArquivoRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: "blob" }).get(`/controle-patrimonio/${idMaquinaEquipArquivo}/download`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#region Controle de Patrimonio Controle

  async getAllControlePatrimonioControle(
    request: GetAllControlePatrimonioControleRequest,
  ): Promise<GetAllControlePatrimonioControleResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllControlePatrimonioControleResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getByIdControlePatrimonioControle(
    request: GetControlePatrimonioControleByIdRequest,
  ): Promise<GetControlePatrimonioControleByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/controle-patrimonio-controle/getbyid/${request.id}`,
      );
      return handleAxiosResponse<GetControlePatrimonioControleByIdResponse>(
        result,
      );
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async createControlePatrimonioControle(
    request: CreateControlePatrimonioControleRequest,
  ): Promise<CreateControlePatrimonioControleResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateControlePatrimonioControleResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateControlePatrimonioControle(
    request: UpdateControlePatrimonioControleRequest,
  ): Promise<UpdateControlePatrimonioControleResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateControlePatrimonioControleResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteControlePatrimonioControle({
    idControleCentroCusto,
  }: DeleteControlePatrimonioControleRequest): Promise<DeleteControlePatrimonioControleResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteControlePatrimonioControleResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllInspecaoMaquinaEquip({
    idControleCentroCusto,
    ...request
  }: GetAllControledePatrimonioInspecaoRequest): Promise<GetAllControledePatrimonioInspecaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/inspecao`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllControledePatrimonioInspecaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getByIdInspecaoMaquinaEquip(
    request: GetControlePatrimonioControleByIdRequest,
  ): Promise<GetControlePatrimonioControleByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/inspecao-maquina-equip/getbyid/${request.id}`,
      );
      return handleAxiosResponse<GetControlePatrimonioControleByIdResponse>(
        result,
      );
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async createInspecaoMaquinaEquip({
    idControleCentroCusto,
    ...request
  }: CreateControledePatrimonioInspecaoRequest): Promise<CreateControledePatrimonioInspecaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/inspecao/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateControledePatrimonioInspecaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateInspecaoMaquinaEquip({
    idControleCentroCusto,
    ...request
  }: UpdateControledePatrimonioInspecaoRequest): Promise<UpdateControledePatrimonioInspecaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/inspecao/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateControledePatrimonioInspecaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteInspecaoMaquinaEquip({
    idControleCentroCusto,
    idInspecaoMaquinaEquip,
  }: DeleteControledePatrimonioInspecaoRequest): Promise<DeleteControledePatrimonioInspecaoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/inspecao/${idInspecaoMaquinaEquip}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteControledePatrimonioInspecaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Maquinas Equip Itens

  async getAllMaquinasEquipItens({
    idMaquinaEquip,
    ...request
  }: GetAllMaquinasEquipItensRequest): Promise<GetAllMaquinasEquipItensResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/${idMaquinaEquip}/items`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllMaquinasEquipItensResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createMaquinasEquipItens({
    idMaquinaEquip,
    ...request
  }: CreateMaquinasEquipItensRequest): Promise<CreateMaquinasEquipItensResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/${idMaquinaEquip}/items/create`,
        request,
      );
      return handleAxiosResponse<CreateMaquinasEquipItensResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async updateMaquinasEquipItens({
    idMaquinaEquip,
    ...request
  }: UpdateMaquinasEquipItensRequest): Promise<UpdateMaquinasEquipItensResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/${idMaquinaEquip}/items/update`,
        request,
      );
      return handleAxiosResponse<UpdateMaquinasEquipItensResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteMaquinasEquipItens({
    idMaquinaEquip,
    idItemMaquinaEquip,
  }: DeleteMaquinasEquipItensRequest): Promise<DeleteMaquinasEquipItensResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/${idMaquinaEquip}/items/${idItemMaquinaEquip}/delete`,
      );
      return handleAxiosResponse<DeleteMaquinasEquipItensResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region Maquina Equip Arquivo

  async getAllControlePatrimonioArquivo({
    idMaquinaEquip,
    ...request
  }: GetAllControlePatrimonioArquivoRequest): Promise<GetAllControlePatrimonioArquivoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/${idMaquinaEquip}/arquivos`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllControlePatrimonioArquivoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMaquinaEquipArquivoById(
    request: GetMaquinaEquipArquivoByIdRequest,
  ): Promise<GetMaquinaEquipArquivoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/maquina-equip-arquivo/getbyid/${request.idMaquinaEquipArquivo}`,
      );
      return handleAxiosResponse<GetMaquinaEquipArquivoByIdResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async createMaquinaEquipArquivo({
    idMaquinaEquip,
    ...request
  }: CreateMaquinaEquipArquivoRequest): Promise<CreateMaquinaEquipArquivoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/${idMaquinaEquip}/arquivos/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateMaquinaEquipArquivoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateMaquinaEquipArquivo({
    idMaquinaEquip,
    ...request
  }: UpdateMaquinaEquipArquivoRequest): Promise<UpdateMaquinaEquipArquivoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/${idMaquinaEquip}/arquivos/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateMaquinaEquipArquivoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteMaquinaEquipArquivo({
    idMaquinaEquip,
    idMaquinaEquipArquivo,
  }: DeleteMaquinaEquipArquivoRequest): Promise<DeleteMaquinaEquipArquivoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/${idMaquinaEquip}/arquivos/${idMaquinaEquipArquivo}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteMaquinaEquipArquivoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  async getControleCentroCustoById({
    idControleCentroCusto,
  }: GetControleCentroCustoByIdRequest): Promise<GetControleCentroCustoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}`,
      );
      const response =
        handleAxiosResponse<GetControleCentroCustoByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getControleCentroCustoEstatisticas({
    idControleCentroCusto,
  }: GetControleCentroCustoEstatisticasRequest): Promise<GetControleCentroCustoEstatisticasResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/estatisticas`,
      );
      const response =
        handleAxiosResponse<GetControleCentroCustoEstatisticasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateMetaStatusControleCentroCusto({
    idControleCentroCusto,
    ...request
  }: UpdateMetaStatusControleCentroCustoRequest): Promise<UpdateMetaStatusControleCentroCustoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/update-meta-status`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateMetaStatusControleCentroCustoResponse>(
          result,
        );
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyInspecaoMaquinaEquip({
    idControleCentroCusto,
    idInspecaoMaquinaEquip,
    ...request
  }: CopyInspecaoMaquinaEquipRequest): Promise<CopyInspecaoMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/inspecao/${idInspecaoMaquinaEquip}/copy`,
        request,
      );
      const response =
        handleAxiosResponse<CopyInspecaoMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getInspecaoMaquinasEquipById({
    idControleCentroCusto,
    idInspecaoMaquinaEquip,
  }: GetInspecaoMaquinasEquipByIdRequest): Promise<GetInspecaoMaquinasEquipByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/inspecao/${idInspecaoMaquinaEquip}`,
      );
      const response =
        handleAxiosResponse<GetInspecaoMaquinasEquipByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllInspecaoMaquinasEquipItem({
    idControleCentroCusto,
    idInspecaoMaquinaEquip,
    ...request
  }: GetAllInspecaoMaquinasEquipItemRequest): Promise<GetAllInspecaoMaquinasEquipItemResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/inspecao/${idInspecaoMaquinaEquip}/itens`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllInspecaoMaquinasEquipItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateInspecaoMaquinasEquipDetail({
    idControleCentroCusto,
    ...request
  }: UpdateInspecaoMaquinasEquipDetailRequest): Promise<UpdateInspecaoMaquinasEquipDetailResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/inspecao/update-details`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateInspecaoMaquinasEquipDetailResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async downloadInspecaoMaquinaEquipArquivo({
    idControleCentroCusto,
    idInspecaoMaquinaEquip,
    fileIndex,
  }: DownloadInspecaoMaquinaEquipArquivoRequest): Promise<DownloadInspecaoMaquinaEquipArquivoResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/controle-centro-custo/${idControleCentroCusto}/inspecao/${idInspecaoMaquinaEquip}/download/${fileIndex}`,
      );
      const response =
        handleAxiosResponse<DownloadInspecaoMaquinaEquipArquivoResponse>(
          result,
        );
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#region Manutencao

  async getAllListagemManutencao(
    request: GetAllManutencaoListaRequest,
  ): Promise<GetAllManutencaoListaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/manutencao/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllManutencaoListaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getManutencaoById(
    request: GetManutencaoByIdRequest,
  ): Promise<GetManutencaoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/manutencao/${request.idManutencao}`,
      );
      const response = handleAxiosResponse<GetManutencaoByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createManutencao(
    request: CreateManutencaoRequest,
  ): Promise<CreateManutencaoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/manutencao/create`,
        formData,
        options,
      );
      const response = handleAxiosResponse<CreateManutencaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteManutencao(
    request: DeleteManutencaoByIdRequest,
  ): Promise<DeleteManutencaoByIdResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/manutencao/delete/${request.idManutencao}`,
      );
      const response =
        handleAxiosResponse<DeleteManutencaoByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateManutencao(
    request: UpdateManutencaoRequest,
  ): Promise<UpdateManutencaoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/manutencao/update`,
        formData,
        options,
      );
      const response = handleAxiosResponse<UpdateManutencaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getManutencaoGerenciarArquivoById({
    idManutencao,
    nroArquivo,
  }: GetManutencaoGerenciarArquivoByIdRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/manutencao/${idManutencao}/arquivo/${nroArquivo}`, {
        responseType: 'blob'
      });
      const response =
        handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion 

  //#region  Checklist Maquina Equip

  async getAllChecklistMaquinaEquip(
    request: GetAllChecklistMaquinaEquipRequest
  ): Promise<GetAllChecklistMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/checklist-maquina-equip/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllChecklistMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getChecklistMaquinaEquipById(
    request: GetChecklistMaquinaEquipByIdRequest
  ): Promise<GetChecklistMaquinaEquipByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/checklist-maquina-equip/${request.idChecklistMaquinaEquip}`
      );
      const response =
        handleAxiosResponse<GetChecklistMaquinaEquipByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createChecklistMaquinaEquip(
    request: CreateChecklistMaquinaEquipRequest
  ): Promise<CreateChecklistMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/checklist-maquina-equip/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateChecklistMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateChecklistMaquinaEquip(
    request: UpdateChecklistMaquinaEquipRequest
  ): Promise<UpdateChecklistMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/checklist-maquina-equip/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateChecklistMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteChecklistMaquinaEquip(
    request: DeleteChecklistMaquinaEquipRequest
  ): Promise<DeleteChecklistMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/checklist-maquina-equip/${request.idChecklistMaquinaEquip}/delete`
      );
      const response =
        handleAxiosResponse<DeleteChecklistMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getChecklistMaquinaEquipDropDown(): Promise<GetChecklistMaquinaEquipDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/checklist-maquina-equip/dropdown`
      );
      const response =
        handleAxiosResponse<GetChecklistMaquinaEquipDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region  Checklist Maquina Equip item

  async getAllChecklistMaquinaEquipItem(
    request: GetAllChecklistMaquinaEquipItemRequest
  ): Promise<GetAllChecklistMaquinaEquipItemResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/item-checklist-maquina-equip/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllChecklistMaquinaEquipItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getChecklistMaquinaEquipItemById(
    request: GetChecklistMaquinaEquipItemByIdRequest
  ): Promise<GetChecklistMaquinaEquipItemByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/item-checklist-maquina-equip/${request.idItemChecklistMaquinaEquip}`,

      );
      const response =
        handleAxiosResponse<GetChecklistMaquinaEquipItemByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }



  async createChecklistMaquinaEquipItem(
    request: CreateChecklistMaquinaEquipItemRequest
  ): Promise<CreateChecklistMaquinaEquipItemResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/item-checklist-maquina-equip/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateChecklistMaquinaEquipItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateChecklistMaquinaEquipItem(
    request: UpdateChecklistMaquinaEquipItemRequest
  ): Promise<UpdateChecklistMaquinaEquipItemResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/item-checklist-maquina-equip/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateChecklistMaquinaEquipItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteChecklistMaquinaEquipItem(
    request: DeleteChecklistMaquinaEquipItemRequest
  ): Promise<DeleteChecklistMaquinaEquipItemResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/item-checklist-maquina-equip/${request.idItemChecklistMaquinaEquip}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteChecklistMaquinaEquipItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion




  //#region Patrimonio Centro Custo

  async getAllPatrimonioCentroCusto(
    request: GetAllPatrimonioCentroCustoRequest
  ): Promise<GetAllPatrimonioCentroCustoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/patrimonio-centro-custo/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllPatrimonioCentroCustoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getPatrimonioCentroCustoById(
    request: GetPatrimonioCentroCustoByIdRequest
  ): Promise<GetPatrimonioCentroCustoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/patrimonio-centro-custo/${request.idPatrimonioCentroCusto}`,
      );
      const response =
        handleAxiosResponse<GetPatrimonioCentroCustoByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createPatrimonioCentroCusto(
    request: CreatePatrimonioCentroCustoRequest
  ): Promise<CreatePatrimonioCentroCustoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/patrimonio-centro-custo/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreatePatrimonioCentroCustoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updatePatrimonioCentroCusto(
    request: UpdatePatrimonioCentroCustoRequest
  ): Promise<UpdatePatrimonioCentroCustoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/patrimonio-centro-custo/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdatePatrimonioCentroCustoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deletePatrimonioCentroCusto(
    request: DeletePatrimonioCentroCustoRequest
  ): Promise<DeletePatrimonioCentroCustoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/patrimonio-centro-custo/${request.idPatrimonioCentroCusto}/delete`,
      );
      const response =
        handleAxiosResponse<DeletePatrimonioCentroCustoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getPatrimonioChecklistInfo(
    request: GetPatrimonioChecklistInfoRequest
  ): Promise<GetPatrimonioChecklistInfoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/inspecao-patrimonio/info`,
        request,
      );
      const response =
        handleAxiosResponse<GetPatrimonioChecklistInfoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion





  //#region Patrimonio Maquina Equip


  async getAllPatrimonioMaquinaEquip(
    request: GetAllPatrimonioMaquinaEquipRequest
  ): Promise<GetAllPatrimonioMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/patrimonio-maquina-equip/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllPatrimonioMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getPatrimonioMaquinaEquipById(
    request: GetPatrimonioMaquinaEquipByIdRequest
  ): Promise<GetPatrimonioMaquinaEquipByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/patrimonio-maquina-equip/${request.idPatrimonioMaquinaEquip}`,
      );
      const response =
        handleAxiosResponse<GetPatrimonioMaquinaEquipByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createPatrimonioMaquinaEquip(
    request: CreatePatrimonioMaquinaEquipRequest
  ): Promise<CreatePatrimonioMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/patrimonio-maquina-equip/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreatePatrimonioMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updatePatrimonioMaquinaEquip(
    request: UpdatePatrimonioMaquinaEquipRequest
  ): Promise<UpdatePatrimonioMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/patrimonio-maquina-equip/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdatePatrimonioMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deletePatrimonioMaquinaEquip(
    request: DeletePatrimonioMaquinaEquipRequest
  ): Promise<DeletePatrimonioMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/patrimonio-maquina-equip/${request.idPatrimonioMaquinaEquip}/delete`,
      );
      const response =
        handleAxiosResponse<DeletePatrimonioMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion



  //#region Patrimonio Checklist Maquina Equip

  async getAllPatrimonioChecklistMaquinaEquip(
    request: GetAllPatrimonioChecklistMaquinaEquipRequest
  ): Promise<GetAllPatrimonioChecklistMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/patrimonio-checklist-maquina-equip/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllPatrimonioChecklistMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getPatrimonioChecklistMaquinaEquipById(
    request: GetPatrimonioChecklistMaquinaEquipByIdRequest
  ): Promise<GetPatrimonioChecklistMaquinaEquipByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/patrimonio-checklist-maquina-equip/${request.idPatrimonioChecklistMaquinaEquip}`,
      );
      const response =
        handleAxiosResponse<GetPatrimonioChecklistMaquinaEquipByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createPatrimonioChecklistMaquinaEquip(
    request: CreatePatrimonioChecklistMaquinaEquipRequest
  ): Promise<CreatePatrimonioChecklistMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/patrimonio-checklist-maquina-equip/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreatePatrimonioChecklistMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updatePatrimonioChecklistMaquinaEquip(
    request: UpdatePatrimonioChecklistMaquinaEquipRequest
  ): Promise<UpdatePatrimonioChecklistMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/patrimonio-checklist-maquina-equip/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdatePatrimonioChecklistMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deletePatrimonioChecklistMaquinaEquip(
    request: DeletePatrimonioChecklistMaquinaEquipRequest
  ): Promise<DeletePatrimonioChecklistMaquinaEquipResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/patrimonio-checklist-maquina-equip/${request.idPatrimonioChecklistMaquinaEquip}/delete`,
      );
      const response =
        handleAxiosResponse<DeletePatrimonioChecklistMaquinaEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Inspecao Patrimonio

  async getAllInspecaoPatrimonio(
    request: GetAllInspecaoPatrimonioRequest
  ): Promise<GetAllInspecaoPatrimonioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/inspecao-patrimonio/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllInspecaoPatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getInspecaoPatrimonioById(
    request: GetInspecaoPatrimonioByIdRequest
  ): Promise<GetInspecaoPatrimonioByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/inspecao-patrimonio/${request.idInspecaoPatrimonio}`,
      );
      const response =
        handleAxiosResponse<GetInspecaoPatrimonioByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createInspecaoPatrimonio(
    request: CreateInspecaoPatrimonioRequest
  ): Promise<CreateInspecaoPatrimonioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/inspecao-patrimonio/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateInspecaoPatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateInspecaoPatrimonio(
    request: UpdateInspecaoPatrimonioRequest
  ): Promise<UpdateInspecaoPatrimonioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/inspecao-patrimonio/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateInspecaoPatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteInspecaoPatrimonio(
    request: DeleteInspecaoPatrimonioRequest
  ): Promise<DeleteInspecaoPatrimonioResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/inspecao-patrimonio/${request.idInspecaoPatrimonio}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteInspecaoPatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Inspecao Patrimonio Itens

  async getAllInspecaoPatrimonioItens(
    request: GetAllInspecaoPatrimonioItensRequest
  ): Promise<GetAllInspecaoPatrimonioItensResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/inspecao-patrimonio-itens/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllInspecaoPatrimonioItensResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getInspecaoPatrimonioItensById(
    request: GetInspecaoPatrimonioItensByIdRequest
  ): Promise<GetInspecaoPatrimonioItensByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/inspecao-patrimonio-itens/${request.idInspecaoPatrimonioItens}`,
      );
      const response =
        handleAxiosResponse<GetInspecaoPatrimonioItensByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createInspecaoPatrimonioItens(
    request: CreateInspecaoPatrimonioItensRequest
  ): Promise<CreateInspecaoPatrimonioItensResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/inspecao-patrimonio-itens/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateInspecaoPatrimonioItensResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateInspecaoPatrimonioItens(
    request: UpdateInspecaoPatrimonioItensRequest
  ): Promise<UpdateInspecaoPatrimonioItensResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/inspecao-patrimonio-itens/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateInspecaoPatrimonioItensResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteInspecaoPatrimonioItens(
    request: DeleteInspecaoPatrimonioItensRequest
  ): Promise<DeleteInspecaoPatrimonioItensResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/inspecao-patrimonio-itens/${request.idInspecaoPatrimonioItens}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteInspecaoPatrimonioItensResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion


  //#region Ocorrencia Inspecao Patrimonio
  async getAllOcorrenciaInspecaoPatrimonio(request: GetAllOcorrenciaInspecaoPatrimonioRequest)
    : Promise<GetAllOcorrenciaInspecaoPatrimonioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/ocorrencia-inspecao-patrimonio/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllOcorrenciaInspecaoPatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getOcorrenciaInspecaoPatrimonioById(request: GetOcorrenciaInspecaoPatrimonioByIdRequest)
    : Promise<GetOcorrenciaInspecaoPatrimonioByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/controle-patrimonio/ocorrencia-inspecao-patrimonio/${request.idOcorrenciaInspecaoPatrimonio}`
      );
      const response =
        handleAxiosResponse<GetOcorrenciaInspecaoPatrimonioByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createOcorrenciaInspecaoPatrimonio(request: CreateOcorrenciaInspecaoPatrimonioRequest)
    : Promise<CreateOcorrenciaInspecaoPatrimonioResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/ocorrencia-inspecao-patrimonio/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateOcorrenciaInspecaoPatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateOcorrenciaInspecaoPatrimonio(request: UpdateOcorrenciaInspecaoPatrimonioRequest)
    : Promise<UpdateOcorrenciaInspecaoPatrimonioResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/controle-patrimonio/ocorrencia-inspecao-patrimonio/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateOcorrenciaInspecaoPatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteOcorrenciaInspecaoPatrimonio(request: DeleteOcorrenciaInspecaoPatrimonioRequest)
    : Promise<DeleteOcorrenciaInspecaoPatrimonioResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/controle-patrimonio/ocorrencia-inspecao-patrimonio/${request.idOcorrenciaInspecaoPatrimonio}/delete`
      );
      const response = handleAxiosResponse<DeleteOcorrenciaInspecaoPatrimonioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async downloadOcorrenciaInspecaoPatrimonioArquivos(request: DownloadOcorrenciaInspecaoPatrimonioArquivosRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({})
        .get(`/controle-patrimonio/ocorrencia-inspecao-patrimonio/ocorrencia/${request.idOcorrenciaInspecaoPatrimonio}/arquivo/${request.nroArquivo}`, {
          responseType: 'blob'
        });
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

}
